/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Sign_In_DescInputs */

const en_directory_submit_sign_in_desc = /** @type {(inputs: Directory_Submit_Sign_In_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need an account to submit a tool.`)
};

const zh_directory_submit_sign_in_desc = /** @type {(inputs: Directory_Submit_Sign_In_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具需要先登录账户。`)
};

/**
* | output |
* | --- |
* | "You need an account to submit a tool." |
*
* @param {Directory_Submit_Sign_In_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_sign_in_desc = /** @type {((inputs?: Directory_Submit_Sign_In_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Sign_In_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_sign_in_desc(inputs)
	return zh_directory_submit_sign_in_desc(inputs)
});
export { directory_submit_sign_in_desc as "directory.submit.sign_in_desc" }